module.exports = __webpack_public_path__ + "static/media/truck9.3f8637cf.svg";